import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { stats } from '../../data/stats';

const WhyChoose = () => (
  <Box component="section" id="why-anr" sx={{ py: { xs: 8, md: 10 }, backgroundColor: 'background.default' }}>
    <Container>
      <Grid container spacing={4}>
        <Grid size={{ xs: 12, md: 5 }}>
          <Typography variant="overline" color="secondary">
            Why Choose ANR
          </Typography>
          <Typography variant="h2" sx={{ mt: 1, color: 'primary.main' }}>
            Mechanical partners focused on safety, schedule & compliance
          </Typography>
          <Typography variant="body1" sx={{ mt: 2 }}>
            Coordinating with owners, GCs, and trade partners, we deliver predictable outcomes through collaborative
            planning, prefabrication, and transparent communication across every project phase.
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, md: 7 }}>
          <Grid container spacing={3}>
            {stats.map((stat) => (
              <Grid size={{ xs: 12, sm: 6 }} key={stat.label}>
                <Card sx={{ height: '100%', textAlign: 'left', borderLeft: '4px solid', borderColor: 'secondary.main' }}>
                  <CardContent>
                    <Typography variant="subtitle2" sx={{ color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 1 }}>
                      {stat.label}
                    </Typography>
                    <Typography variant="h5" sx={{ mt: 1 }}>
                      {stat.value}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Container>
  </Box>
);

export default WhyChoose;
